module.exports = __webpack_public_path__ + "img/thomas.f34e3d3d.png";